import React, { memo, useCallback, useEffect, useState } from "react";
import * as XLSX from "xlsx";

import { useHistory } from "react-router-dom";
import { Routes } from "../../AppRoutes";
import { ConfirmDeletePopup } from "../../components/confirm-delete-popup";
import { Image } from "../../components/image";
import { TableFilterInputText } from "../../components/table-filter-inputs";
import { Button, CreateAlert, Icon, ITableStructureItem } from "../../modules";
import { TableSimplePagination } from "../../modules/table/TableSimplePagination";
import { AppService } from "../../services/app";

const ApkList = () => {
  const history = useHistory()

  const [dataList, setDataList] = useState<any>();
  const [filterParams, setFilterParams] = useState<any>({
    page: 1,
    pageSize: 10,
  });
  const [loading, setLoading] = useState(false);
  const [activeDelete, setActiveDelete] = useState<{
    open: boolean;
    data: any;
  }>({
    open: false,
    data: undefined,
  });

  const fetchData = useCallback(async () => {
    setLoading(true);
    const data = await AppService.getList(filterParams);
    setDataList(data);
    setLoading(false);
  }, [filterParams]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleDelete = async (data: any) => {
    try {
      const res = await AppService.delete(data?.data?.appId);

      if (res?.success) {
        setActiveDelete({ open: false, data: undefined });
        const _params = { page: 1, pageSize: 10 };
        setFilterParams({ ..._params });
        CreateAlert({
          type: "success",
          message: "Xóa dữ liệu thành công",
        });
      }
    } catch (error: any) {
      setActiveDelete({ open: false, data: undefined });
      CreateAlert({
        type: "danger",
        message: error.message || "Xóa dữ liệu thất bại",
      });
    }
  };

  const structure: ITableStructureItem[] = [
    {
      name: "STT",
      key: "_order",
    },
    {
      name: "Hình ảnh",
      key: "imageUrl",
      render: (item: any) => (
        <Image src={item?.imageUrl} style={{ maxWidth: 80, height: "auto" }} />
      ),
    },
    {
      name: "Tên file apk",
      key: "name",
      render: (item: any) => item?.name || "--",
    },
    {
      name: "Package name",
      key: "packageName",
      render: (item: any) => item?.packageName || "--",
    },
    {
      name: "Dung lượng file",
      key: "installFileSize",
      render: (item: any) => item?.installFileSize ? `${(item?.installFileSize / 1024)?.toFixed(2)}mb` : "--",
    },
    {
      name: "Version",
      key: "version",
    },
    {
      name: "Trạng thái",
      key: "isActive",
      render: (item) => (item?.isActive ? "Kích hoạt" : "Khóa"),
    },
    {
      name: "Thao tác",
      key: "singerId",
      render: (item: any) => {
        return (
          <div className="btnGroup">
            <span
              className="btn btn-edit"
              onClick={() => history.push(Routes.apkModify.renderPath(item?.appId))}
            >
              <Icon.Edit />
            </span>

            <span
              className="btn"
              onClick={() =>
                setActiveDelete({
                  open: true,
                  data: item,
                })
              }
            >
              <Icon.Delete />
            </span>

            
          </div>
        );
      },
    },
  ];

  const filters = [
    {
      name: "Tìm kiếm theo tên file apk",
      key: "searchString",
      input: (s: any) => (
        <TableFilterInputText
          {...s}
          params={{
              ...s?.params,
              searchString: filterParams?.searchString,
          }}
        />
      ),
    }
  ]  

  const handleExportExcel = async () => {
    return new Promise(async (resolve) => {
      try {
        const response = await AppService.getList({
          ...filterParams,
          page: 1,
          pageSize: 1000000,
        });

        const data = response.data;

        const fileHead = structure.map((v) => v.name);
        const dataExport = [
          fileHead,
          ...data.map((item: any) =>
            structure.map((column, index) => {
              if (!column.key) return "";
              return item[column.key];
            })
          ),
        ];

        const ws = XLSX.utils.aoa_to_sheet(dataExport);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "SheetJS");

        const now = new Date();
        XLSX.writeFile(
          wb,
          `App-list-${now.toLocaleDateString().replace(/\//g, "-")} ${now
            .toLocaleTimeString()
            .replace(/:/g, "-")}.xlsx`,
          { type: "binary" }
        );

        resolve(
          CreateAlert({
            type: "success",
            message: "Export data success.",
          })
        );
      } catch (error: any) {
        resolve(CreateAlert({ type: "danger", message: error.message }));
      }
    });
  };

  return (
    <>
      <div className="apk-container">
        <div className="title">Quản lý file APK</div>

        <div className="content">
          <div className="wrap-action-header">
            <Button
              className="mb20"
              label="Xuất excel"
              buttonType="success"
              onClick={handleExportExcel}
            />

            <Button
              className="mb20"
              label="Tạo mới"
              buttonType="success"
              onClick={() => history.push(Routes.apkCreate.path)}
            />
          </div>

          <TableSimplePagination
            dataTable={{
              dataList: dataList,
              filterParams: filterParams,
              totalPage: dataList
                ? Math.ceil(dataList?.count / filterParams?.pageSize)
                : 0,
              loading,
            }}
            setParams={setFilterParams}
            filters={filters}
            structure={structure}
          />
        </div>
      </div>

      {activeDelete?.open && (
        <ConfirmDeletePopup
          onClose={() => setActiveDelete({ open: false, data: undefined })}
          onConfirm={() => handleDelete(activeDelete)}
        />
      )}
    </>
  );
};

export default memo(ApkList);
